import { apiSlice } from './apiSlice';

export const authApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Login
    login: builder.mutation<
      {
        success: boolean;
        accessToken?: string;
        type: string;
        role: { id: number; name: string };
        passwordChanged: boolean;
        mfaRequired?:boolean;
        isTelegramEnabled?:boolean;
      },
      {
        username: string;
        password: string;
        device: string;
        isTermCondition: boolean;
      }
    >({
      query: (body) => ({
        url: '/auth/login',
        method: 'POST',
        body,
      }),
    }),

    //logout
    logout: builder.mutation<any, void>({
      query: () => ({
        url: '/auth/logout',
        method: 'POST',
      }),
    }),

    // change password
    changePassword: builder.mutation({
      query: (body: { oldPassword: string; newPassword: string }) => ({
        url: '/users/me/change-password',
        method: 'POST',
        body,
      }),
    }),

    //Demo Login
    demoLogin: builder.mutation<any, void>({
      query: () => ({
        url: '/auth/demo/login',
        method: 'POST',
      }),
    }),
  }),
});

export const {
  useLoginMutation,
  useLogoutMutation,
  useChangePasswordMutation,
  useDemoLoginMutation,
} = authApi;
